import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import axios from 'axios';
import { Grid, Box, TextField, Typography, Pagination, Button, Modal } from '@mui/material';
import ProjectCard from './ProjectCard';

const ProjectList = ({ searchQueryFreeword, searchQueryWorkstyle, searchQueryTagOptions, searchQueryReward, searchQueryUtilizationRate, searchQueryOfficeOrHome }) => {
  const [projects, setProjects] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedProject, setSelectedProject] = useState(null);
  const [open, setOpen] = useState(false);
  const projectsPerPage = 10;

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL || 'https://consultingstudio.xii.jp/api'}/projects?screen=list`)
      .then(response => {
        // 非表示でないプロジェクトのみSET
        const displayProjects = response.data.filter(project => project.hidden_flag === 0);
        setProjects(displayProjects);
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleOpen = (project) => {
    setSelectedProject(project);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedProject(null);
  };

  const handleApply = () => {
    sessionStorage.setItem("selectedProject", JSON.stringify(selectedProject));
    const storedUserInfo = JSON.parse(localStorage.getItem("userInfo"));
    const storedAuthToken = localStorage.getItem("authToken");
    if (storedUserInfo || storedAuthToken) { // 新旧どちらかログイン情報がある場合
      window.location.href = '/questionnaire';
    }
    else {
      window.location.href = '/registration';
    }
  };

  const filteredProjects = projects.filter(project => {
    const matchesFreeword = searchQueryFreeword === '' || (
      (project.title && project.title.toLowerCase().includes(searchQueryFreeword.toLowerCase()))
      || (project.overview && project.overview.toLowerCase().includes(searchQueryFreeword.toLowerCase()))
      || (project.required_skills && project.required_skills.toLowerCase().includes(searchQueryFreeword.toLowerCase()))
      || (project.preferred_skills && project.preferred_skills.toLowerCase().includes(searchQueryFreeword.toLowerCase()))
    );
    const matchesWorkstyle = searchQueryWorkstyle === '' || (project.work_style && project.work_style.toLowerCase().includes(searchQueryWorkstyle.toLowerCase()));
    
    const projectTags = project.tag.split(',');
    const { industory, skill, consul_layer } = searchQueryTagOptions;
    const matchesTagIndustry = industory.length === 0 || (project.tag && industory.some(tag => projectTags.includes(tag)));
    const matchesTagSkill = skill.length === 0 || (project.tag && skill.some(tag => projectTags.includes(tag)));
    const matchesTagConsulLayer = consul_layer.length === 0 || (project.tag && consul_layer.some(tag => projectTags.includes(tag)));

    const matchesLowerReward = searchQueryReward.lower_reward === '' || (project.lower_reward && !isNaN(searchQueryReward.lower_reward) && project.lower_reward >= searchQueryReward.lower_reward)
    const matchesUpperReward = searchQueryReward.upper_reward === '' || (project.upper_reward && !isNaN(searchQueryReward.upper_reward) && project.upper_reward <= searchQueryReward.upper_reward)

    const matchesLowerUtilizationRate = searchQueryUtilizationRate.lower_utilization_rate === '' || (project.lower_utilization_rate && !isNaN(searchQueryUtilizationRate.lower_utilization_rate) && project.lower_utilization_rate >= searchQueryUtilizationRate.lower_utilization_rate)
    const matchesUpperUtilizationRate = searchQueryUtilizationRate.upper_utilization_rate === '' || (project.upper_utilization_rate && !isNaN(searchQueryUtilizationRate.upper_utilization_rate) && project.upper_utilization_rate <= searchQueryUtilizationRate.upper_utilization_rate)

    const matchesOfficeOrHome = searchQueryOfficeOrHome === '' || (project.office_or_home && project.office_or_home === searchQueryOfficeOrHome);

    return matchesFreeword && matchesWorkstyle && matchesTagIndustry && matchesTagSkill && matchesTagConsulLayer && matchesLowerReward && matchesUpperReward && matchesLowerUtilizationRate && matchesUpperUtilizationRate && matchesOfficeOrHome;
  });


  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);

  const convertStartDate = (startDate) => {
    const startDateObj = new Date(startDate);
    const now = new Date();
    // 開始日を過ぎている場合は即日表示とする
    if (startDateObj.valueOf() < now.valueOf()) {
      return '即日';
    } else {
      return startDateObj.toLocaleDateString()
    };
  }

  const convertReward = (selectedProject) => {
    const { lower_reward, upper_reward } = selectedProject;
    if (lower_reward == upper_reward) {
      return `${lower_reward}万円/人月`
    } else {
      return `${lower_reward}〜${upper_reward}万円/人月`
    }
  }

  const convertUtilizationRate = (selectedProject) => {
    const { lower_utilization_rate, upper_utilization_rate } = selectedProject;
    if (lower_utilization_rate == upper_utilization_rate) {
      return `${lower_utilization_rate}%`
    } else {
      return `${lower_utilization_rate}〜${upper_utilization_rate}%`
    }
  }

  return (
    <Box>
      <Grid container>
        {currentProjects.length > 0 ? (
          currentProjects.map((project) => (
            <Grid item key={project.id}
              style={{
                width: '100%', // 幅を100%に設定
                padding: '0',
              }}
              onClick={() => handleOpen(project)}
            >
              <ProjectCard project={project} />
            </Grid>
          ))
        ) : (
          <Typography variant="h6" align="center" sx={{ marginTop: 2 }}>
            データが見つかりません
          </Typography>
        )}
      </Grid>
      <Pagination
        count={Math.ceil(filteredProjects.length / projectsPerPage)}
        page={currentPage}
        onChange={handlePageChange}
        color="primary"
        sx={{ marginTop: 2, display: 'flex', justifyContent: 'center' }}
      />
      <Modal open={open} onClose={handleClose}>

        <Box
          sx={{
            backgroundColor: 'white',
            padding: 4,
            borderRadius: 2,
            boxShadow: 24,
            width: '90%',
            maxWidth: '80vw',
            maxHeight: '80vh',
            overflowY: 'auto',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          {selectedProject && (
            <>
              <Typography
                variant="body2"
                style={{ fontSize: '1rem', color: '#666' }} // 文字サイズと色を変更
              >
                {selectedProject.tag}
              </Typography>
              <Typography
                variant="body2"
                component="div"
                style={{ fontSize: '1.1rem', color: '#1D55B5', fontWeight: 'bold' }} // 文字サイズと色を変更
              >
                {selectedProject.title}
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell>概要</TableCell>
                      <TableCell sx={{ whiteSpace: 'pre-line' }}>{selectedProject.overview}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>報酬</TableCell>
                      <TableCell>{convertReward(selectedProject)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>勤務形態</TableCell>
                      <TableCell>{selectedProject.work_style}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>稼働率</TableCell>
                      <TableCell>{convertUtilizationRate(selectedProject)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>開始日</TableCell>
                      <TableCell>{convertStartDate(selectedProject.start_date)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>必要なスキル</TableCell>
                      <TableCell sx={{ whiteSpace: 'pre-line' }}>{selectedProject.required_skills}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>尚可スキル</TableCell>
                      <TableCell sx={{ whiteSpace: 'pre-line' }}>{selectedProject.preferred_skills}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
            <Button variant="contained" color="secondary" onClick={handleClose} sx={{ marginRight: 1 }}>
              閉じる
            </Button>
            <Button variant="contained" color="primary" onClick={handleApply}>
              応募する
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ProjectList;

